import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4238ecbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-modal__dialog" }
const _hoisted_2 = {
  key: 0,
  class: "base-modal__header"
}
const _hoisted_3 = {
  key: 1,
  class: "base-modal__body"
}
const _hoisted_4 = {
  key: 2,
  class: "base-modal__footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "modal",
      appear: ""
    }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "base-modal",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleBackdropClick && _ctx.handleBackdropClick(...args)), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_1, [
                (_ctx.$slots.header)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _renderSlot(_ctx.$slots, "header", {}, undefined, true),
                      _createElementVNode("button", {
                        class: "base-modal__close",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                      }, "×")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.$slots.body)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _renderSlot(_ctx.$slots, "body", {}, undefined, true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.$slots.footer)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}